/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Contrôles permettant de manipuler le slideshow
 */
(function($g, createjs, lib) {
    "use strict";
    var Slideshow = $g.Slideshow;
    var CenterBtn = $g.CenterBtn;
    var BottomBar = $g.BottomBar;

    var paral = $g.paral;

    var STATES = Slideshow.STATES;
    var UNSTARTED = STATES.UNSTARTED;
    var PLAYING = STATES.PLAYING;
    var PAUSED = STATES.PAUSED;
    var COMPLETED = STATES.COMPLETED;

    var SHOW_DURATION = 2000;

    var HIDDEN = {};
    var SHOWING = {};
    var VISIBLE = {};
    var HIDDING = {};

    function PlayControls(slideshow, mPlayer) {
        var me = this;
        var centerBtn = me.centerBtn;
        var bottomBar = me.bottomBar;
        var lastAct;
        var etat = HIDDEN;
        var size = me.size;
        me.autohide = false;

        function appear() {
            etat= SHOWING;

            paral(
                centerBtn.show,
                bottomBar.show,
                function() {
                    etat = VISIBLE;
                }
            );
        }

        function disappear() {
            etat=HIDDING;
            paral(
                centerBtn.hide,
                bottomBar.hide,
                function() {
                    etat = HIDDEN;
                }
            );
        }

        me.update = function() {
            var now = new Date().getTime();
            var ract = now - lastAct < SHOW_DURATION;
            var e = slideshow.etat;
            var forceshow=(e===UNSTARTED)||(e===COMPLETED);
            var dshow=(e===PLAYING)||(e===PAUSED);
            var show = forceshow||(ract&&dshow)||!me.autohide;
            if (etat===HIDDEN) {
                if (show) {
                    appear();
                }
            } else if (etat===VISIBLE) {
                if (!show) {
                    disappear();
                }
            }

            if (etat!==HIDDEN) {
                centerBtn.update();
                bottomBar.update(size);
                var aib =  1-bottomBar.alpha;
                bottomBar.x = -size.gapX;
                bottomBar.y = -size.gapY+size.height + aib * bottomBar.nominalBounds.height;
            }
        };

        function act() {
            lastAct = new Date().getTime();
        }

        function enable() {
            var stage = me.stage;
            stage.on("stagemousemove", act);
            stage.on("stagemousedown", act);
            stage.on("stagemouseup", act);
        }

        function init() {
            CenterBtn.call(centerBtn, slideshow);
            BottomBar.call(bottomBar, slideshow, mPlayer);

            centerBtn.setRectHitArea(centerBtn.nominalBounds);
        }

        enable();
        init();
    }

    $g.PlayControls = PlayControls;

})(PVPGEngine, createjs, lib);
